export default __webpack_public_path__ + "static/media/employeeIcon.809b25ac.svg";